<template>
    <DetailsSection class="step">
        <template slot="header">
            <media-only desktop>
                <span class="step-number"> </span>
            </media-only>
            {{ $t('Cancellation.header.reason') }}
        </template>

        <div class="form-row">
            <div class="form-group col-12">
                <select
                    :value="cancellationReason"
                    :name="$t('Cancellation.header.reason')"
                    class="form-control input-gray custom-select"
                    :aria-label="$t('Cancellation.cancel.reason.placeholder')"
                    @change="$emit('update:cancellationReason', $event.target.value)"
                    required
                >
                    <option value="" disabled selected>{{ $t('Cancellation.cancel.reason.placeholder') }}</option>
                    <option v-for="reason in cancellationReasons" :key="reason.translationKey" :value="reason.value">
                        {{ $t(reason.translationKey) }}
                    </option>
                </select>
            </div>
            <div class="form-group col-12">
                <textarea
                    :value="cancellationText"
                    @input="updateTextarea"
                    :maxlength="reasonMaxlength"
                    :placeholder="$t('Cancellation.cancel.reason.text', { max: reasonMaxlength })"
                    rows="7"
                    class="form-control input-gray message"
                    :required="cancellationReason === 'Other'"
                    :aria-label="$t('Cancellation.cancel.reason.text', { max: reasonMaxlength })"
                >
                </textarea>
            </div>
        </div>
    </DetailsSection>
</template>

<script>
import cancellationReasons from '@/models/CancellationReasons';
import DetailsSection from '@/components/DetailsSection';

export default {
    name: 'CancellationForm',
    components: {
        DetailsSection
    },
    data() {
        return {
            cancellationReasons,
            reasonMaxlength: 5000
        };
    },
    props: {
        cancellationText: String,
        cancellationReason: String
    },
    methods: {
        updateTextarea(event) {
            const value = event.target.value || '';
            this.$emit('update:cancellationText', value);
        }
    }
};
</script>

<style scoped></style>
